import { IDLE } from './components/pages/App/constants';

export default {
  badgesCap: {
    currentOrgDetails: {},
    user: {},
    users: {},
    sidebarMenuData: [],
    topbarMenuData: [],
    fetchingUserdata: IDLE,
    // getLastSyncTimeStatus: '',         //UNUSED, maybe needed later on as per requirement
    // lastSyncTime: '',
    getProgramFilterTypeStatus: '',
    programFilterType: {},
    lastSyncTimeError: null,
    programFilterTypeError: null,
    getFieldDataStatus: '',
    allContributors: [],
    entities: {},
    getFieldDataError: null,
  },
};
